import { bdayGet, bdayPost, bdayPut } from 'services/utils';

const baseApi = '/api/1/payment';

export const addPayment = (data, action) => {
  return bdayPost(`${baseApi}/${action}`, data);
}
export const syncMembership = (data) => {
  return bdayGet(`${baseApi}/sync_membership${data ? data : ''}`);
}
export const getCoupons = () => {
  return bdayGet(`${baseApi}/coupon`);
}
export const addCoupon = (data) => {
  return bdayPost(`${baseApi}/coupon`, data);
}
export const updateCoupon = (data) => {
  return bdayPut(`${baseApi}/coupon`, data);
}
export const cancelSubscription = (data) => {
  return bdayPost(`${baseApi}/cancel_subscription`, data);
}
export const cancelRenewal = (data) => {
  return bdayPost(`${baseApi}/cancel_renewal`, data);
}
export const autoRenew = (data) => {
  return bdayPost(`${baseApi}/auto_renew`, data || {});
}
export const getOffers = (data) => {
  const { search, ...payload } = data;
  return bdayPost(`${baseApi}/offers${search ? search : ''}`, payload);
}
export const adminResetPremium = (data) => {
  return bdayPost(`${baseApi}/admin/reset`, data);
}
export const adminExpirePremium = (data) => {
  return bdayPost(`${baseApi}/admin/expire`, data);
}
